<table mat-table [dataSource]="dataSource" class="mosaic-material-theme">
  <ng-container matColumnDef="long_name" sticky>
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" class="metric-name">
      <a
        class="metric-link"
        [routerLink]="'/metric/settings/editor/' + element.kpi_id"
        title="Navigate to Metric Settings Editor"
      >
        {{ element.long_name }}
      </a>
    </td>
  </ng-container>

  <!-- Turn On Column -->
  <ng-container matColumnDef="visible">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <visibility-toggle
        class="visibility-slide-toggle"
        [visible]="element.visible"
        [visTable]="true"
        (toggledEvent)="visibilityToggled(element)"
      ></visibility-toggle>
    </td>
  </ng-container>

  <!-- Display For All Schools Column -->
  <ng-container matColumnDef="all">
    <th class="accelerator" mat-header-cell *matHeaderCellDef>
      DISPLAY FOR ALL SCHOOLS
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox
        [(ngModel)]="element.selectedAll"
        [(indeterminate)]="element.selectedSome"
        [disabled]="!element.visible"
        (change)="selectAllChecked(element)"
        class="helper-checkbox"
      ></mat-checkbox>
    </td>
  </ng-container>

  <ng-container
    *ngFor="let category of helperCategories"
    [matColumnDef]="category"
  >
    <th class="accelerator" mat-header-cell *matHeaderCellDef>
      DISPLAY FOR ALL {{ category | uppercase }}
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox
        [(ngModel)]="element['selectedAll' + category]"
        [(indeterminate)]="element['selectedSome' + category]"
        [disabled]="!element.visible"
        (change)="helperCategoryChecked(element, category)"
        class="helper-checkbox"
      ></mat-checkbox>
    </td>
  </ng-container>

  <!-- Display For Schools Column -->
  <ng-container matColumnDef="multi_schools">
    <th mat-header-cell *matHeaderCellDef>DISPLAY FOR SCHOOL(S)</th>
    <td mat-cell *matCellDef="let element">
      <ng-select
        [items]="schools"
        [multiple]="true"
        [closeOnSelect]="false"
        [bindLabel]="bindLabel"
        [groupBy]="groupBy"
        [placeholder]="placeholder"
        [disabled]="!element.visible"
        [(ngModel)]="element.systemSchoolIds"
        bindValue="systemSchoolId"
        (change)="updateAccelerators(element)"
        class="school-select"
        *ngIf="schools"
      >
        <ng-template ng-multi-label-tmp let-items="items">
          <ng-container *ngIf="items.length == schools.length">
            <!-- All schools selected case -->
            <div class="ng-value">
              <span class="ng-value-label" matTooltip="All Schools Selected">
                All Schools
              </span>
              <span
                class="ng-value-icon right filter-dropdown-select-value-icon"
                (click)="clearAll(element)"
                aria-hidden="true"
                >×</span
              >
            </div>
          </ng-container>
          <ng-container *ngIf="items.length < schools.length">
            <!-- Fewer than all schools selected case -->
            <div
              class="ng-value"
              *ngFor="let item of items ? items.slice(0, numItemsShown) : []"
            >
              <span class="ng-value-label" [matTooltip]="item[bindLabel]">
                {{
                  item[bindLabel] && item[bindLabel].length > 15
                    ? (item[bindLabel] | slice: 0:15) + "..."
                    : item[bindLabel]
                }}
              </span>
              <span
                class="ng-value-icon right filter-dropdown-select-value-icon"
                (click)="clearSchool(item, element)"
                aria-hidden="true"
                >×</span
              >
            </div>
            <div class="ng-value" *ngIf="items.length > numItemsShown">
              <span class="ng-value-label"
                >{{ items.length - numItemsShown }} more...</span
              >
            </div>
          </ng-container>
        </ng-template>
      </ng-select>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
